<template>
  <PublicLayout>
    <h1 class="public__title">FAQ</h1>
    <p class="public__lead">Les réponses aux questions les plus fréquentes sur Saineo.</p>
    
<h2 class="public__section-title">Qu’est-ce que Saineo ?</h2>
    <p class="public__text">
      Saineo est une plateforme de nutrition personnalisée qui génère automatiquement des plans de repas hebdomadaires sans produits ultra-transformés, adaptés au profil de santé, aux objectifs alimentaires et aux conditions médicales de chaque utilisateur.
    </p>
    
      <h2 class="public__section-title">Puis-je exclure certains aliments ?</h2>
    <p class="public__text">
      Oui. Vous pouvez indiquer vos allergies, intolérances et aliments non souhaités dans votre profil.
    </p>

    <h2 class="public__section-title">Les recettes sont-elles scientifiquement validées ?</h2>
    <p class="public__text">
      Les recettes et les règles nutritionnelles sont co-développées avec des professionnels de la nutrition afin de garantir des plans alimentaires équilibrés et cohérents avec les connaissances scientifiques actuelles.
    </p>

     <h2 class="public__section-title">Quelles pathologies Saineo prend-il en compte ?</h2>
    <p class="public__text">
      Aujourd'hui, Saineo intègre les allergies alimentaires, l'intolérance au gluten, la maladie coeliaque, l'intolérance au lactose, 
      l'endométriose, le SOPK, le prédiabète et le diabète de type 2.
    </p>

     <h2 class="public__section-title">Puis-je utiliser Saineo si je n’ai pas de problème de santé particulier ?</h2>
    <p class="public__text">
      Oui. Saineo s’adresse également aux personnes qui souhaitent simplement mieux manger, contrôler leur poids ou suivre des objectifs nutritionnels spécifiques comme la prise de masse musculaire.
    </p>

    <h2 class="public__section-title">Dois-je passer beaucoup de temps à organiser mes repas ?</h2>
    <p class="public__text">
      Non. Saineo génère automatiquement votre plan alimentaire hebdomadaire. Cela vous permet de gagner du temps en sachant quoi manger chaque jour et quelles courses acheter !
    </p>

      <h2 class="public__section-title">Dois-je compter mes calories ou peser mes aliments ?</h2>
    <p class="public__text">
     Non. L’objectif de Saineo est de simplifier l’alimentation en proposant des repas équilibrés, sans obliger les utilisateurs à suivre ou calculer leurs calories.
    </p>

          <h2 class="public__section-title">En quoi Saineo est-il différent des autres applications de nutrition ?</h2>
    <p class="public__text">
      Saineo se concentre sur une nutrition personnalisée prenant en compte des aspects médicaux, à partir de recettes validées par des experts, plutôt que sur des recommandations générées automatiquement par des systèmes d’IA générative.
    </p>

     <h2 class="public__section-title">Comment contacter Saineo ?</h2>
    <p class="public__text">
     Vous pouvez nous contacter à l'adresse contact@saineo.eu.
    </p>
    
  </PublicLayout>
</template>

<script>
import PublicLayout from './PublicLayout.vue';

export default {
  name: 'FaqPage',
  components: { PublicLayout },
};
</script>
